/* eslint-disable react/jsx-pascal-case */
import React from "react";
import PropTypes from "prop-types";
import FolderDocumentsCardAlpha from "./FolderDocumentsCardAlpha";

const FolderDocumentsContainerAlpha = ({ documentId, siteId, history, onChangeActiveStep }) => {
  const onDocumentsHistoryClick = fileId => {
    onChangeActiveStep(-1);
    history.push(`/folders/${documentId}/${siteId}/documentHistory/${fileId}`);
  };

  return (
    <FolderDocumentsCardAlpha
      documentId={documentId}
      siteId={siteId}
      onDocumentsHistoryClick={onDocumentsHistoryClick}
    />
  );
};

FolderDocumentsContainerAlpha.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  onChangeActiveStep: PropTypes.func.isRequired
};

export default FolderDocumentsContainerAlpha;
